var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"edit",on:{"click":function($event){$event.preventDefault();return _vm.refresh()}}},[_vm._v(" Re-calculate crew hours ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }